import { createContext, useCallback, useRef, useState } from "react";
import api from "../api/client";

export const SuperAdminAuthContext = createContext({
  admin: null,
  adminLoading: false,
  adminSessionChecked: false,
  refreshAdminAuth: async () => {},
  setAdmin: () => {},
  adminLogout: async () => {},
});

export const SuperAdminAuthProvider = ({ children }) => {
  const [admin, setAdminState] = useState(null);
  const [adminLoading, setAdminLoading] = useState(false);
  const [adminSessionChecked, setAdminSessionChecked] = useState(false);
  const seq = useRef(0);

  const setAdmin = useCallback((value) => {
    seq.current += 1;
    setAdminState(value);
    setAdminLoading(false);
    setAdminSessionChecked(true);
  }, []);

  const refreshAdminAuth = useCallback(() => {
    const id = ++seq.current;
    setAdminLoading(true);
    return (async () => {
      try {
        const res = await api.get("/api/superauth/superadmin/me", {
          timeout: 20_000,
          skipSessionExpired: true,
        });
        if (id !== seq.current) return;
        setAdminState(res.data?.admin || null);
      } catch {
        if (id !== seq.current) return;
        setAdminState(null);
      } finally {
        if (id === seq.current) {
          setAdminLoading(false);
          setAdminSessionChecked(true);
        }
      }
    })();
  }, []);

  const adminLogout = useCallback(async () => {
    try {
      await api.post("/api/superauth/superadmin/logout");
    } catch {
      // ignore
    } finally {
      setAdmin(null);
    }
  }, [setAdmin]);

  return (
    <SuperAdminAuthContext.Provider
      value={{ admin, adminLoading, adminSessionChecked, refreshAdminAuth, setAdmin, adminLogout }}
    >
      {children}
    </SuperAdminAuthContext.Provider>
  );
};
